import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TabModel } from '../models';

@Injectable({
  providedIn: 'root',
})

export class TabNavigationService {
  public activatedTab$: BehaviorSubject<TabModel> = new BehaviorSubject(new TabModel());
}
